import { css } from 'styled-components';

import { colors, media } from '../../../core';
import { SelectInputProps } from './SelectInput.types';

export default ({ labelType, showIndicatorAnimation = true }: SelectInputProps) => css`
  .react-select {
    &__input {
      color: ${({ theme }) => theme.selectColor || colors.ash};
      font-size: ${({ theme }) => theme.fontSize || '14px'};
      font-family: ${({ theme }) => theme.fontFamily || `Quicksand, sans-serif`};
    }

    &__multi-value__label {
      padding: 0 3px;
      p {
        padding: 0;
      }
    }

    &__control {
      min-height: 36px;
      height: auto;
      cursor: pointer;
      border: 1px solid transparent;
      border-radius: 3px 3px 0 0;
      border-bottom-color: ${colors.cloud};
      font-size: ${({ theme }) => theme.fontSize || '14px'};
      padding: ${({ theme }) => theme.selectInputPadding || '3px 8px'};
      background-color: transparent;
      height: auto;

      ${media.tabletPortrait} {
        padding: 12px;
        border: 0;
        border-bottom: 1px solid ${colors.cloud};
      }

      ${() =>
        labelType === 'inside' &&
        `
          padding-left: 100px;

          ${media.tabletPortrait} {
            padding-left: 100px;
          }
        `}

      &:hover {
        box-shadow: 0 2px 4px 0 rgba(217, 217, 217, 0.5);
        border-color: ${colors.cloud};
        border-bottom-color: ${colors.cloud};
      }

      &--is-focused,
      &--is-focused:hover {
        box-shadow: none;
        outline: 0;
        border-color: ${colors.cloud};
        border-bottom-color: ${colors.cloud};

        .react-select__single-value {
          border-color: 'transparent';
        }
      }

      &--is-disabled {
        background-color: 'transparent';
        border-color: 'transparent';
        border-bottom-color: ${colors.cloud};
        box-shadow: none;

        .react-select__single-value {
          color: ${colors.smoke};
        }
      }

      &--is-disabled svg path {
        fill: ${colors.smoke};
      }

      &--menu-is-open {
        .react-select__indicator {
          ${({ theme }) =>
            showIndicatorAnimation &&
            theme.selectShowIndicatorAnimation &&
            `
            transform: rotate(-180deg);
            transition: transform 0.3s;
          `}
        }
      }
    }

    &__value-container {
      padding: 0;
    }

    &__placeholder,
    &__single-value,
    &__option {
      font-family: ${({ theme }) => theme.fontFamily || `Quicksand, sans-serif`};
      font-size: ${({ theme }) => theme.fontSize || '14px'};
      line-height: ${({ theme }) => theme.fontLineHeight || '1.5'};
      font-weight: ${({ theme }) => theme.fontWeight || `600`};
    }

    &__placeholder {
      color: ${({ theme }) => theme.selectPlaceholderColor || colors.smoke};
    }

    &__single-value {
      color: ${({ theme }) => theme.selectColor || colors.ash};
    }

    &__indicator-separator {
      background-color: transparent;
      width: 8px;
    }

    &__indicator {
      padding: 7px 8px;
      ${({ theme }) =>
        showIndicatorAnimation &&
        theme.selectShowIndicatorAnimation &&
        `
            transform: rotate(0);
            transition: transform 0.3s;
          `}
    }

    &__menu {
      border-radius: 0 0 3px 3px;
      margin-top: 0;
      overflow: hidden;
      transform: translateZ(0);
      display: block;
      border: 1px solid ${colors.cloud};
      border-top: 0;
      box-shadow: none;

      ${media.tabletPortrait} {
        background-color: ${colors.pearl};
        border: 0;
      }

      &-notice--no-options {
        text-align: left;
        color: ${({ theme }) => theme.fontColor || colors.ash};
        font-size: ${({ theme }) => theme.fontSize || '14px'};
        font-family: ${({ theme }) => theme.fontFamily || `Quicksand, sans-serif`};
        padding: 8px 27px;
      }
    }

    &__menu-list {
      padding: 0;

      &--is-multi {
        label {
          line-height: ${({ theme }) => theme.selectOptionMultiLineHeight || '1.5'};
          margin-top: ${({ theme }) => theme.selectOptionMultiMargin || '0'};
        }
      }
    }

    &__option {
      background-color: ${colors.white};
      text-align: left;
      color: ${({ theme }) => theme.fontColor || colors.ash};
      cursor: pointer;
      padding: 8px 27px;

      ${media.tabletPortrait} {
        padding: 20px 27px;
        background-color: ${colors.pearl};
      }

      &:hover {
        background-color: ${colors.pearl};
      }

      &:active {
        background-color: ${colors.pearl};
      }

      &--is-selected,
      &--is-selected:active {
        font-weight: 600;
        color: ${({ theme }) => theme.selectOptionActiveColor || colors.charcoal};
      }
    }

    &__group-heading {
      color: ${({ theme }) => theme.selectColor || colors.charcoal};
      font-size: 12px;
      font-family: ${({ theme }) => theme.fontFamily || `Quicksand, sans-serif`};
      padding: 8px 20px;
      font-weight: bold;
    }
  }
`;
